import React, { useState, useEffect } from 'react';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-inner">
        <div className="cookie-text">
          <span className="cookie-icon">&#127850;</span>
          <p>This site uses cookies for authentication, security, and to remember your preferences. By clicking "Accept", you consent to our use of cookies. <a href="#" className="cookie-link" onClick={e => e.preventDefault()}>Learn more</a></p>
        </div>
        <div className="cookie-actions">
          <button onClick={handleDecline} className="cookie-btn cookie-btn-decline">Decline</button>
          <button onClick={handleAccept} className="cookie-btn cookie-btn-accept">Accept</button>
        </div>
      </div>
      <style>{`
        .cookie-banner {
          position: fixed; bottom: 0; left: 0; right: 0; z-index: 9999;
          background: #1a1a2e; border-top: 1px solid #2a2a4a;
          padding: 16px 20px; animation: slideUp 0.3s ease-out;
        }
        @keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }
        .cookie-inner {
          max-width: 1200px; margin: 0 auto;
          display: flex; align-items: center; justify-content: space-between;
          gap: 20px; flex-wrap: wrap;
        }
        .cookie-text { display: flex; align-items: flex-start; gap: 10px; flex: 1; min-width: 280px; }
        .cookie-icon { font-size: 1.4rem; flex-shrink: 0; margin-top: 2px; }
        .cookie-text p { color: #aaaacc; font-size: 0.85rem; line-height: 1.5; margin: 0; }
        .cookie-link { color: #f7971e; text-decoration: underline; }
        .cookie-actions { display: flex; gap: 10px; flex-shrink: 0; }
        .cookie-btn {
          padding: 10px 20px; border-radius: 8px; font-size: 0.85rem;
          font-weight: 600; cursor: pointer; border: none; transition: opacity 0.2s;
        }
        .cookie-btn:hover { opacity: 0.85; }
        .cookie-btn-accept { background: linear-gradient(135deg, #f7971e, #ffd200); color: #1a1a2e; }
        .cookie-btn-decline {
          background: transparent; border: 1px solid #3a3a5a; color: #8888aa;
        }
        .cookie-btn-decline:hover { border-color: #8888aa; color: #fff; }
        @media (max-width: 640px) {
          .cookie-inner { flex-direction: column; }
          .cookie-actions { width: 100%; }
          .cookie-btn { flex: 1; text-align: center; }
        }
      `}</style>
    </div>
  );
};

export default CookieBanner;
